import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()
import "@hotwired/turbo-rails"
import "flowbite/dist/flowbite.turbo.js";
import "./controllers"
import "trix"
import "@rails/actiontext"
import "./lib/action_pack/passkey"
import "./lib/keep_open_modal_on_morph"
